export default function HeroRecycleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
    >
      <rect
        width="78.712"
        height="78.712"
        x=".976"
        y=".643"
        fill="#FFF3E6"
        rx="39.356"
      />
      <path
        fill="#F80"
        d="m51.468 55.919-1.437-5.082c-10.747 9.502-19.686.755-21.316-1.757l.829-.512a1.182 1.182 0 0 0-.108-2.067l-7.432-3.583a1.172 1.172 0 0 0-1.132.06 1.177 1.177 0 0 0-.56.985l-.127 8.25a1.182 1.182 0 0 0 1.8 1.022l.396-.245c6.814 11.055 22.455 12.138 30.92 4.92a3.018 3.018 0 0 1-1.834-1.991ZM26.372 42.953c-.874-4.737 2.27-14.37 12.707-15.505v.125a1.18 1.18 0 0 0 1.815.995l6.954-4.44a1.18 1.18 0 0 0 0-1.99l-6.954-4.442a1.179 1.179 0 0 0-1.815.994v1.3c-10.137-.043-20.918 9.54-20.224 22.467 0 0 1.57-1.522 2.637-1.522.898 0 1.058.176 4.88 2.018Zm35.443 6.521a1.18 1.18 0 0 0-.814-.886l-.85-.257c2.501-7.004 1.69-19.087-9.973-25.837.044.208.08.42.08.638a3.033 3.033 0 0 1-1.406 2.567l-4.016 2.564c3.557 1.027 11.688 7.366 8.17 17.912l-.51-.153a1.18 1.18 0 0 0-1.477 1.45l2.243 7.94a1.18 1.18 0 0 0 1.904.574l6.262-5.372a1.18 1.18 0 0 0 .387-1.14Z"
      />
    </svg>
  )
}
